module.exports = __webpack_public_path__ + "media/images/fp-img-e50cef89da460dd7de81463e73f0d634.jpg";